import { render, staticRenderFns } from "./BlockAssistantModal.vue?vue&type=template&id=6d638f48&"
import script from "./BlockAssistantModal.vue?vue&type=script&lang=js&"
export * from "./BlockAssistantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports